/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

// import Vue from 'vue';
// import store from '@/store';
// import * as types from './mutation-types';
/*
import API from '@/api/';
export const fetchPlanList = ({
  commit
}) => {
  return new Promise((resolve) => {
    API.plan.fetchPlanList().then(res => {
      if (res.status === 200) {
        commit(`plan/SET_PLANLIST`, {
          items: res.data
        }, {
          root: true
        })
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    })
  });
};
*/
import API from '@/api/'
export const list = ({ commit },params) => {
  return new Promise((resolve) => {
    API.organization.list(params).then(res => {
      if (res.status === 200) {
        commit(`organization/SET_LIST`, res.data.data, {
          root: true
        });
        commit(`organization/SET_TOTAL`, res.data.total, {
          root: true
        });
        commit(`organization/SET_OFFSET`, res.data.offset, {
          root: true
        });
        commit(`organization/SET_MAX`, res.data.max, {
          root: true
        });
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const add = ({ commit },params) => {
  return new Promise((resolve) => {
    API.organization.add(params).then(res => {
      if (res.status === 201) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const get = ({ commit },id) => {
  return new Promise((resolve) => {
    API.organization.get(id).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    })
  })
}
export const getWithTags = ({ commit },id) => {
  return new Promise((resolve) => {
    API.organization.getWithTags(id).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    })
  })
}
export const getWithGroups = ({ commit },id) => {
  return new Promise((resolve) => {
    API.organization.getWithGroups(id).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    })
  })
}
export const update = ({ commit },params) => {
  return new Promise((resolve) => {
    API.organization.update(params).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    })
  })
}
export const remove = ({ commit },params) => {
  return new Promise((resolve) => {
    API.organization.remove(params).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export default {
  list,
  add,
  update,
  remove,
  get,
  getWithGroups,
  getWithTags
};